import { HttpStatusCode } from 'owa-http-status-codes';
import AttachmentResultCode from 'owa-service/lib/contract/AttachmentResultCode';
import GetAttachmentDataProviderItemsResponse from 'owa-service/lib/contract/GetAttachmentDataProviderItemsResponse';
import { trace } from 'owa-trace';

export default function handleGetItemsResponse<TResult>(
    result: TResult,
    errorResponse: null,
    createGetItemsResponse: (result: TResult) => GetAttachmentDataProviderItemsResponse,
    createFailedGetItemsResponse: (
        resultCode: AttachmentResultCode
    ) => GetAttachmentDataProviderItemsResponse
): GetAttachmentDataProviderItemsResponse;
export default function handleGetItemsResponse<TResult>(
    result: null,
    errorResponse: Response,
    createGetItemsResponse: (result: TResult) => GetAttachmentDataProviderItemsResponse,
    createFailedGetItemsResponse: (
        resultCode: AttachmentResultCode
    ) => GetAttachmentDataProviderItemsResponse
): GetAttachmentDataProviderItemsResponse;
export default function handleGetItemsResponse<TResult>(
    result: TResult,
    errorResponse: Response,
    createGetItemsResponse: (result: TResult) => GetAttachmentDataProviderItemsResponse,
    createFailedGetItemsResponse: (
        resultCode: AttachmentResultCode
    ) => GetAttachmentDataProviderItemsResponse
): GetAttachmentDataProviderItemsResponse {
    if (result) {
        return createGetItemsResponse(result);
    } else {
        // Calls via fetchService don't get errorReponse returned.
        trace.warn(errorResponse?.statusText);

        // We are doing if/else because there are only 3 cases. If more cases are added switch to using a map.
        if (errorResponse?.status === HttpStatusCode.NotFound) {
            return createFailedGetItemsResponse(AttachmentResultCode.NotFound);
        } else if (
            errorResponse?.status === HttpStatusCode.Unauthorized ||
            errorResponse?.status === HttpStatusCode.Forbidden
        ) {
            return createFailedGetItemsResponse(AttachmentResultCode.AccessDenied);
        }

        return createFailedGetItemsResponse(AttachmentResultCode.GenericFailure);
    }
}
